import { useSettings } from "@/context/SettingsContext";
import { useLang } from "@/context/LanguageContext";
import RichText from "@/components/RichText";
import Seo from "@/components/Seo";

// Renders an admin-editable legal page (Terms / Privacy / Disclaimer) from
// site settings. `pageKey` selects which document to show.
export default function LegalPage({ pageKey }) {
  const { legal_pages = {} } = useSettings();
  const { pick } = useLang();
  const page = legal_pages[pageKey] || {};
  const title = page.title || (pageKey ? pageKey[0].toUpperCase() + pageKey.slice(1) : "");

  return (
    <>
      <Seo path={`/${pageKey}`} title={`${title} · Dharmartha`} description={title} />
      <section className="mx-auto max-w-3xl px-5 py-16 md:px-8 md:py-24" data-testid={`legal-page-${pageKey}`}>
        <p className="overline-label mb-3 text-gold">{pick("धर्मार्थ", "Dharmartha")}</p>
        <h1 className="font-serif-latin text-4xl text-ink md:text-5xl" data-testid="legal-title">{title}</h1>
        {page.updated && (
          <p className="mt-3 text-sm text-ink-3" data-testid="legal-updated">
            {pick("अंतिम अद्यतन", "Last updated")}: {page.updated}
          </p>
        )}
        <div className="mt-10 border-t border-line pt-10">
          {page.body ? (
            <RichText value={page.body} className="max-w-none" />
          ) : (
            <p className="text-ink-2">{pick("यह पृष्ठ शीघ्र उपलब्ध होगा।", "This page will be available soon.")}</p>
          )}
        </div>
      </section>
    </>
  );
}
